import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createIndividualConsultationDocument, updateIndividualConsultationDocument } from './actions';
import IndividualConsultationDocumentSettingsForm from './SettingsForm';
import authUtils from '../../auth/utils';

const Details = ({ match, history, paymentId, isReadonly, individualConsultationDocument, createIndividualConsultationDocument, updateIndividualConsultationDocument, documentType, paymentHistoryDocumentTypes }) => {
	const handleIndividualConsultationDocumentSettingsSubmit = (values) => {
		Object.assign(values, { paymentId });
		if (individualConsultationDocument) {
			updateIndividualConsultationDocument(individualConsultationDocument.id, values);
		} else {
			createIndividualConsultationDocument(values, history);
		}
	};

	if (individualConsultationDocument) {
		return (
			<IndividualConsultationDocumentSettingsForm isReadonly={isReadonly} onSubmit={handleIndividualConsultationDocumentSettingsSubmit} initialValues={individualConsultationDocument}
				paymentHistoryDocumentTypes={paymentHistoryDocumentTypes}/>
		);
	} else {
		return <IndividualConsultationDocumentSettingsForm isReadonly={isReadonly} initialValues={{ type: documentType }} onSubmit={handleIndividualConsultationDocumentSettingsSubmit}
			paymentHistoryDocumentTypes={paymentHistoryDocumentTypes}/>;
	}	
};

const mapStateToProps = (state, ownProps) => {
	const individualConsultationDocumentId = ownProps.match.params.individualConsultationDocumentId;

	const {
		entities: { individualConsultationDocuments },
		lookups: { paymentHistoryDocumentTypes },
		auth: { currentUser }
	} = state;

	return {
		individualConsultationDocument: individualConsultationDocuments[individualConsultationDocumentId],
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'IndividualConsultationDocuments'),
		documentType: ownProps.documentType,
		paymentHistoryDocumentTypes
	};
};

export default connect(mapStateToProps, {
	createIndividualConsultationDocument,
	updateIndividualConsultationDocument
})(Details);